import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import NotFoundPage from '../pages/NotFoundPage';
import TI from './brand/TI';

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-[#E63946] border-t-transparent rounded-full animate-spin" />
          <p className="text-[#5B6577] text-sm tracking-wide">
            <TI color="#E63946" />
          </p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}

export function AdminRoute({ children }) {
  const { user, loading, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-[#E63946] border-t-transparent rounded-full animate-spin" />
          <p className="text-[#5B6577] text-sm tracking-wide">
            <TI color="#E63946" />
          </p>
        </div>
      </div>
    );
  }

  // Hide-on-anonymous: enterprise portal directive bans leaking the existence
  // of admin/assessor tooling to unauthenticated visitors. Anonymous AND
  // authenticated-but-non-admin users get a 404 surface — same response,
  // same status code, no information disclosure.
  if (!user || !isAdmin) {
    return <NotFoundPage />;
  }

  return children;
}

export function ReviewerRoute({ children }) {
  // Accepts ag_reviewer + admin. Hide-on-anonymous semantics identical to
  // AdminRoute — non-reviewers see a 404, never a 403, so we never leak
  // the existence of the reviewer surface.
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="flex flex-col items-center gap-4">
          <div className="w-10 h-10 border-4 border-[#E63946] border-t-transparent rounded-full animate-spin" />
          <p className="text-[#5B6577] text-sm tracking-wide">
            <TI color="#E63946" />
          </p>
        </div>
      </div>
    );
  }

  const role = user?.role;
  if (!user || (role !== 'admin' && role !== 'ag_reviewer')) {
    return <NotFoundPage />;
  }

  return children;
}

